module.exports = __webpack_public_path__ + "static/img/import_guid_img.8e538644.png";